import React, { useEffect, useState } from 'react'

import { string } from 'prop-types'

import LoadingState from 'Pods/ThreeDStudio/Shared/LoadingState/LoadingState'

let ImageGalleryPanel = null
let imageGalleryImportPromise = null

export const importImageGalleryPanel = () => {
  if (!imageGalleryImportPromise) {
    imageGalleryImportPromise = import(
      /* webpackChunkName: "image-gallery-panel" */
      'Pods/LazyLoaded/ImageGalleryPanel/ImageGalleryPanel'
    ).then((mod) => { ImageGalleryPanel = mod.default })
  }
  return imageGalleryImportPromise
}

function LazyImageGalleryPanel({ initialSearchQuery = '' }) {
  const [isLoaded, setIsLoaded] = useState(() => !!ImageGalleryPanel)

  useEffect(() => {
    if (!ImageGalleryPanel) {
      importImageGalleryPanel().then(() => setIsLoaded(true))
    }
  }, [])

  if (!isLoaded || !ImageGalleryPanel) return <LoadingState />
  return <ImageGalleryPanel initialSearchQuery={initialSearchQuery} />
}

LazyImageGalleryPanel.propTypes = {
  initialSearchQuery: string,
}

export default LazyImageGalleryPanel
